import {useContext, useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import MediaContext from "../../context/MediaContext";
import Visualization from "./Visualization";

const SAMPLE_MS = 50
const DECAY = 0.85
const FLOOR = 0.05
const SCALE = 10

export default () => {
    const {volumeMeter} = useContext(MediaContext)
    const {t} = useTranslation()
    const [level, setLevel] = useState(0)
    const levelRef = useRef(0)

    // Not read off the context's `volume` — depending on it would block RISKS.md/P2.19.
    useEffect(() => {
        // The level drives this bar and nothing else: never warn from silence (RISKS.md/P2.44).
        const sample = () => {
            const decayed = Math.max(volumeMeter.getVolume(), levelRef.current * DECAY)
            const next = decayed < FLOOR ? 0 : decayed
            if (next === levelRef.current) return
            levelRef.current = next
            setLevel(next)
        }
        const interval = setInterval(sample, SAMPLE_MS)
        return () => clearInterval(interval)
    }, [volumeMeter])

    return (
        <div className="level-meter" role="img" aria-label={t('lobby.microphoneLevel')}>
            <Visualization max={SCALE} value={level}/>
        </div>
    )
}
